interface CoHostInvitationDetails {
  eventTitle: string;
  eventStartDate: string;
  eventStartTime?: string;
  eventLocation?: string;
  eventImageUrl?: string;
  coHostName: string;
  invitationUrl: string;
}

export function getCoHostInvitationEmailTemplate(details: CoHostInvitationDetails) {
  const subject = `Te invitaron a co-organizar: ${details.eventTitle}`;
  
  const formattedDate = new Date(details.eventStartDate).toLocaleDateString('es-AR', {
    weekday: 'long', 
    month: 'long', 
    day: 'numeric',
    year: 'numeric'
  });
  
  const body = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>${subject}</title>
      <style>
        body {
          font-family: 'Helvetica Neue', Arial, sans-serif;
          line-height: 1.6;
          color: #333;
          margin: 0;
          padding: 0;
          background-color: #f9f9f9;
        }
        .email-container {
          max-width: 600px;
          margin: 0 auto;
          background-color: #ffffff;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 4px 8px rgba(0,0,0,0.05);
        }
        .header {
          background-color: #8B5CF6; /* Purple for co-host */
          padding: 30px 0;
          text-align: center;
          color: white;
        }
        .header h1 {
          margin: 0;
          color: white;
          font-size: 24px;
        }
        .content {
          padding: 30px;
        }
        .event-image {
          width: 100%;
          height: auto;
          border-radius: 6px;
          margin-bottom: 20px;
        }
        h2 {
          color: #333;
          margin-top: 0;
        }
        .event-details {
          background-color: #f5f7fa;
          padding: 20px;
          border-radius: 6px;
          margin: 20px 0;
        }
        .detail-row {
          display: flex;
          margin-bottom: 15px;
        }
        .detail-label {
          width: 120px;
          font-weight: bold;
          color: #666;
        }
        .detail-value {
          flex: 1;
        }
        .cta-button {
          display: inline-block;
          background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
          color: white !important;
          text-decoration: none;
          padding: 14px 30px;
          border-radius: 6px;
          font-weight: bold;
          margin-top: 20px;
          text-align: center;
        }
        .secondary-link {
          display: block;
          margin-top: 15px;
          color: #666;
          text-align: center;
          font-size: 12px;
        }
        .footer {
          padding: 20px 30px;
          text-align: center;
          font-size: 12px;
          color: #999;
          border-top: 1px solid #eee;
        }
        .benefits-list {
          margin: 25px 0;
          padding: 0;
        }
        .benefits-list li {
          margin-bottom: 10px;
          list-style-type: none;
          padding-left: 30px;
          position: relative;
        }
        .benefits-list li:before {
          content: "✓";
          position: absolute;
          left: 0;
          color: #8B5CF6; /* Purple for co-host */
          font-weight: bold;
        }
      </style>
    </head>
    <body>
      <div class="email-container">
        <div class="header">
          <h1>INVITACIÓN DE CO-ORGANIZADOR</h1>
        </div>
        <div class="content">
          <h2>¡Fuiste invitado a co-organizar un evento!</h2>
          <p>Hola ${details.coHostName},</p>
          <p>Te invitaron a ayudar a gestionar el siguiente evento:</p>
          
          ${details.eventImageUrl ? `<img src="${details.eventImageUrl}" alt="${details.eventTitle}" class="event-image">` : ''}
          
          <h2>${details.eventTitle}</h2>
          
          <div class="event-details">
            <div class="detail-row">
              <div class="detail-label">Fecha:</div>
              <div class="detail-value">${formattedDate}</div>
            </div>
            ${details.eventStartTime ? `
            <div class="detail-row">
              <div class="detail-label">Hora:</div>
              <div class="detail-value">${details.eventStartTime}</div>
            </div>` : ''}
            ${details.eventLocation ? `
            <div class="detail-row">
              <div class="detail-label">Lugar:</div>
              <div class="detail-value">${details.eventLocation}</div>
            </div>` : ''}
          </div>
          
          <p>Como co-organizador, vas a poder:</p>
          
          <ul class="benefits-list">
            <li>Ver la lista de asistentes y sus detalles</li>
            <li>Marcar asistencia durante el evento</li>
            <li>Ayudar con la coordinación general</li>
          </ul>
          
          <center>
            <a href="${details.invitationUrl}" class="cta-button">Aceptar invitación de co-organizador</a>
          </center>
          
          <p class="secondary-link">Este enlace seguro expirará en 7 días.</p>
        </div>
        <div class="footer">
          <p>Esta invitación fue enviada por Punta Tech Meetup. Si creés que la recibiste por error, ignorá este correo.</p>
        </div>
      </div>
    </body>
    </html>
  `;

  return { subject, body };
}